export const convertChineseCurrencyToNumber = (chineseCurrency) => {
    // 中文数字到阿拉伯数字的映射
    const chineseNumerals = {
        '零': 0, '壹': 1, '贰': 2, '叁': 3, '肆': 4,
        '伍': 5, '陆': 6, '柒': 7, '捌': 8, '玖': 9
    };
    // 单位及其对应的数值
    const units = {
        '厘': 0.001, '分': 0.01, '角': 0.1, '元': 1, '圆':1,
        '拾': 10, '佰': 100, '仟': 1000,'万': 10000, '亿': 100000000
    };
    // 处理多位连续相同单位的情况，例如“佰佰”对应200
    const processedUnits = { ...units };
    for (let unit in units) {
        if (unit.length > 1) {
            processedUnits[unit.slice(1)] = units[unit];
        }
    }

    // 将中文金额转为数组方便处理
    const parts = chineseCurrency.split('');
    let result = 0;
    let unitValue = 1;  // 当前单位的值，初始化为个位
    let lastNumeral = null;  // 上一个数字字符

    for (let i = parts.length - 1; i >= 0; i--) {
        const char = parts[i];
        if (char in chineseNumerals) {
            const num = chineseNumerals[char];
            if (num !== 0) {
                result += num * unitValue;
                lastNumeral = num;  // 更新上一个数字字符为当前数字
            } else if (lastNumeral !== null) {
                // 处理连续的零，例如“壹零零”应视为“壹”
                result += unitValue;
            }
        } else if (char in processedUnits) {
            unitValue = processedUnits[char];  // 更新单位值
            if (char === '亿') {
                // 亿后面的单位要重新开始计算（万、千、百等）
                unitValue *= 10000;  // 先乘以1亿，后面会再乘以其他单位值
            } else if (char === '万') {
                unitValue *= 10000;  // 万之前的单位要乘以1万
            } else if (char === '元') {
                unitValue = 1;  // 元之后的单位重新开始计算（角、分）
            }
            lastNumeral = null;  // 重置上一个数字字符为null，因为单位改变了
        }
    }
    return result;
}
